import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";

const useDefault = () => {
  const dispatch = useDispatch();
  const [config, setConfig] = useState(null);

  useEffect(() => {
    if (config) {
      const { title, message, onFinish } = config;
      dispatch({
        type: "TOGGLE_REACT_PRETTY_ALERT",
        properties: {
          title,
          message,
          open: true,
          type: "default",
          stacktrace: null,
          buttons: [
            {
              title: "OK",
              main: true,
              onClick: () => {
                dispatch({
                  type: "TOGGLE_REACT_PRETTY_ALERT",
                  open: false
                });
                if (onFinish) onFinish();
              }
            }
          ]
        }
      });
    }

    setConfig(null); // Limpa a propriedade para não repetir a mensagem.
  }, [config, dispatch]);

  return ({ title, message, onFinish }) => {
    setConfig({ title, message, onFinish });
  };
};

export default useDefault;
